module.exports = __webpack_public_path__ + "img/social-hub.80e6ba43.png";